import { render, staticRenderFns } from "./ThumbArtista.vue?vue&type=template&id=c73bb6a8&scoped=true"
import script from "./ThumbArtista.vue?vue&type=script&lang=js"
export * from "./ThumbArtista.vue?vue&type=script&lang=js"
import style0 from "./ThumbArtista.vue?vue&type=style&index=0&id=c73bb6a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c73bb6a8",
  null
  
)

export default component.exports